import { useContext, useEffect, useState } from "react";
import IconsContainer from "src/components/icons/others/IconsContainer";
import PropTypes from "prop-types";
import ProgressCirc from "src/components/layout/Progress/ProgressCirc";
import { Button, Fade, Grid, Tooltip, Typography } from "@mui/material";
import MySkeleton from "src/components/layout/MySkeleton";
import { KeikkaDataContext } from "src/context/KeikkaDataContext";
import { tyomaa_ajoOhje_getString } from "src/data/tyomaa/tyomaaFunctions";

export default function TyomaaRow(props) {
  const { keikkaData } = useContext(KeikkaDataContext) || {};

  const fadeTime = 500;

  const [ajoOhjeet, setAjoOhjeet] = useState();
  useEffect(() => {
    if (keikkaData) {
      const a = tyomaa_ajoOhje_getString(keikkaData.tyomaa);
      setAjoOhjeet(a);
    }
  }, [
    keikkaData.tyomaa.tyomaaId,
    keikkaData.tyomaa.tyomaaAjoOhje,
    keikkaData.tyomaa.keikkaAjoOhje,
  ]);

  const isError =
    keikkaData.auth.edit &&
    keikkaData.tila.keikkaTilaId < 5 &&
    (keikkaData.tyomaa.tyomaaError(keikkaData.tila.keikkaTilaId < 4) != null ||
      keikkaData.asiakas.asiakasError(keikkaData.tila.keikkaTilaId < 4) != null);

  return (
    <div style={{ padding: isError ? "10px" : "0px", transition: "all 0.6s ease-in-out" }}>
      <Tooltip
        disableInteractive
        title={
          isError &&
          (keikkaData.tyomaa.tyomaaError(keikkaData.tila.keikkaTilaId < 4) ||
            keikkaData.asiakas.asiakasError(keikkaData.tila.keikkaTilaId < 4) ||
            "")
        }
        placement="top-end"
        arrow>
        <Button
          variant={keikkaData.auth.edit && keikkaData.tyomaa.tyomaaError() ? "outlined" : "text"}
          sx={{ minHeight: "70px", margin: 0, padding: 0 }}
          onClick={props.onClick}
          fullWidth
          aria-label="Muokkaa työmaata">
          <div className="flexCol" style={{ width: "100%" }}>
            <Grid container className="stepRow" sx={{ width: "100%" }}>
              <Grid size={{ xs: 3 }} sx={{ textAlign: "right" }}>
                <Typography
                  variant="h6"
                  sx={{ paddingRight: "5px", transition: "all 1.2s ease-in-out" }}
                  noWrap
                  color="primary"
                  className="fixPrint">
                  Asiakas:
                </Typography>
              </Grid>
              {keikkaData.keikkaId === 0 || keikkaData.isLoading ? (
                <MySkeleton width="70%" height="35px" />
              ) : (
                keikkaData.tyomaa &&
                keikkaData.auth.read && (
                  <>
                    <Fade in={true} timeout={fadeTime}>
                      <Grid size={{ xs: 8 }} sx={{ paddingTop: "5px", textAlign: "left" }}>
                        <Typography
                          noWrap
                          color={keikkaData.asiakas.asiakasId > 0 ? "primary" : "warning.main"}
                          className="fixPrint"
                          sx={{ transition: "all 1.2s ease-in-out" }}>
                          {keikkaData.asiakas.asiakasId > 0 && keikkaData.asiakas.asiakasNimi}
                          {keikkaData.asiakas.asiakasId == 0 &&
                            (keikkaData.auth.edit
                              ? "Syötä laskutustiedot"
                              : "Laskutustiedot puuttuu")}
                        </Typography>
                      </Grid>
                    </Fade>
                    <Fade in={true} timeout={fadeTime}>
                      <Grid size={{ xs: 1 }} className="frontPageEditIcon">
                        <IconsContainer
                          showWarning={
                            keikkaData.tyomaa.tyomaaError() ||
                            keikkaData.asiakas.asiakasError() != null
                              ? true
                              : false
                          }
                          showEdit={keikkaData.auth.edit}
                          editOpacity={0.5}
                        />
                      </Grid>
                    </Fade>
                  </>
                )
              )}
            </Grid>
            <Grid container className="stepRow" sx={{ width: "100%" }}>
              <Grid size={{ xs: 3 }} sx={{ textAlign: "right" }}>
                <Typography
                  variant="h6"
                  sx={{ paddingRight: "5px", transition: "all 1.2s ease-in-out" }}
                  noWrap
                  color="primary"
                  className="fixPrint">
                  Osoite:
                </Typography>
              </Grid>
              {keikkaData.keikkaId === 0 || keikkaData.isLoading ? (
                <MySkeleton width="70%" height="35px" />
              ) : (
                keikkaData.tyomaa &&
                keikkaData.auth.read && (
                  <>
                    <Fade in={true} timeout={fadeTime}>
                      <Grid size={{ xs: 8 }} sx={{ paddingTop: "5px", textAlign: "left" }}>
                        <Typography
                          noWrap
                          className="fixPrint"
                          color={keikkaData.tyomaa.tyomaaId > 0 ? "primary" : "warning.main"}
                          sx={{ transition: "all 1.2s ease-in-out" }}>
                          {keikkaData.tyomaa.tyomaaNimi != keikkaData.asiakas.asiakasNimi &&
                            keikkaData.tyomaa.tyomaaId > 0 &&
                            keikkaData.tyomaa.tyomaaNimi.length > 0 && (
                              <>
                                {keikkaData.tyomaa.tyomaaNimi}
                                <br />
                              </>
                            )}
                          {keikkaData.asiakas.asiakasId < 0 ||
                            (keikkaData.tyomaa.tyomaaId < 0 && <ProgressCirc />)}
                          {keikkaData.tyomaa.tyomaaId > 0 && keikkaData.tyomaa.tyomaaOsoiteString}
                          {keikkaData.tyomaa.tyomaaId == 0 &&
                            (keikkaData.auth.edit
                              ? "Syötä toimitusosoite"
                              : "Toimitusosoite puuttuu")}
                        </Typography>
                        {ajoOhjeet && ajoOhjeet.length > 0 && (
                          <Typography
                            className="fixPrint"
                            variant="body2"
                            color="primary"
                            sx={{ transition: "all 1.2s ease-in-out" }}
                            noWrap>
                            {ajoOhjeet}
                          </Typography>
                        )}
                      </Grid>
                    </Fade>
                  </>
                )
              )}
            </Grid>
          </div>
        </Button>
      </Tooltip>
    </div>
  );
}

TyomaaRow.propTypes = {
  onClick: PropTypes.func,
};
